import { render, staticRenderFns } from "./smsMarketing.vue?vue&type=template&id=2011d009&"
import script from "./smsMarketing.vue?vue&type=script&lang=js&"
export * from "./smsMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports